import "./App.css";
import React, { useState } from "react";
import {
  HashRouter,
  Navigate,
  BrowserRouter as Router,
  useRoutes,
} from "react-router-dom";

// import { setCookie } from './component/service/CookieManagement';
// import { HttpRequest } from './component/service/HttpRequest';

import LoginPage from "./page/login";
import HomePage from "./page/home";
import DashboardPage from "./page/dashboard";
import ReportPage from "./page/report";
import Spinner from "./component/spinner";
import NavigationBar from "./component/navbar";

import {
  useGlobalContext,
  GlobalContextProvider,
  setConfigApp,
} from "./component/service/GlobalContext";
import MenuThree from "./page/menu3";
import MenuOne from "./page/menu1";
import MenuTwo from "./page/menu2";

// HttpRequest ที่ fetch json
import { HttpRequest } from "./service/HttpRequest";
import { caldistance, cal_1, cal_2, cal_3 } from "./utils/calculation";

// สมมติว่า HttpRequest มี method สำหรับ fetch JSON
const fetchJsonData = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching JSON data:", error);
    return null;
  }
};

///////////////////////////////////////////////////////

const getConfig = () => {
  const Request = new Promise((resolve, reject) => {
    fetch(`${process.env.PUBLIC_URL}/config.json`)
      .then((res) => res.json())
      .then((config) => {
        // console.log(config);
        resolve(config);
      })
      .catch((err) => {
        console.log(err, " error");
      });
  });

  return Request;
};

const MainRoute = () => {
  const [loading, setLoading] = React.useState(false);

  const [globalState, setGlobalState] = useGlobalContext();

  const [jsonData, setJsonData] = React.useState(null);

  let routeList = [
    // { path: "/dashboard", name: "dashboard", displayName: "Dashboard", element: <DashboardPage />, enable: true },
    // {
    //   path: "/dashboard",
    //   name: "dashboard",
    //   displayName: "Dashboard",
    //   element: <DashboardPage />,
    //   enable: true,
    // },
    // { path: "/home", name: "home", displayName: "Home", element: <HomePage />, enable: true },
    // { path: "/report", name: "report", displayName: "Report", element: <ReportPage />, enable: true },
    // { path: "/dashboard", name: "dashboard", displayName: "Dashboard", element: <DashboardPage />, enable: true },
    {
      path: "/passenger",
      name: "passenger",
      displayName: "Passenger",
      element: (
        <MenuOne data={jsonData} caldistance={caldistance} cal_1={cal_1} />
      ),
      enable: true,
    },
    {
      path: "/transport",
      name: "transport",
      displayName: "Transport",
      element: <MenuTwo data={jsonData} cal_2={cal_2} />,
      enable: true,
    },
    {
      path: "/agencies",
      name: "agencies",
      displayName: "Agencies",
      element: <MenuThree data={jsonData} cal_3={cal_3} />,
      enable: true,
    },
  ];

  let dropdownRouteList = [
    // {
    //   name: "report", displayName: "REPORT", enable: true, routeList: [
    //     { name: "report_traffic_hour" , displayName: "ปริมาณจราจรรายชั่วโมง", enable: true },
    //     { name: "report_traffic_week" , displayName: "ปริมาณจราจรต่อวันรายสัปดาห์", enable: true },
    //     { name: "report_traffic_month", displayName: "ปริมาณจราจรต่อวันรายเดือน", enable: true },
    //     { name: "report_traffic_year" , displayName: "ปริมาณจราจรต่อวันรายปี", enable: true },
    //   ]
    // },
  ];

  let menuList = [];

  let PrivateRoutes = [
    // { path: "*", element: <Navigate replace to="/dashboard" /> },
    // { path: "/login", element: <Navigate replace to="/dashboard" /> },
  ];

  let PublicRoutes = [
    { path: "*", element: <Navigate replace to="/dashboard" /> },
    { path: "/dashboard", element: <LoginPage /> },
  ];

  for (let i = 0; i < routeList.length; i++) {
    const route = routeList[i];
    if (route.enable === true) {
      menuList.push({
        path: route.path,
        name: route.name,
        displayName: route.displayName,
      });
    }
    PrivateRoutes.push({ path: route.path, element: route.element });
    PublicRoutes.push({
      path: route.path,
      element: <Navigate replace to="/login" />,
    });
  }

  const routeUse = globalState.auth ? PrivateRoutes : PublicRoutes;
  // const IntitailRoute = useRoutes(routeUse);
  const IntitailRoute = useRoutes(routeUse);

  // React.useEffect(() => {
  //   const controller = new AbortController();

  //   // console.log("PrivateRoutes", PrivateRoutes);
  //   //  console.log("PublicRoutes", PrivateRoutes);

  //   async function onSetConfigApp() {
  //     let config_app = await getConfig();
  //     setConfigApp(setGlobalState, config_app);
  //   }

  //   onSetConfigApp();

  //   return () => {
  //     controller.abort();
  //   };
  // }, []);

  // Data
  React.useEffect(() => {
    const controller = new AbortController();

    async function initializeApp() {
      setLoading(true);
      let config_app = await getConfig();
      setConfigApp(setGlobalState, config_app);

      const data = await fetchJsonData(`${process.env.PUBLIC_URL}/data.json`);
      setJsonData(data);
      console.log("jsonData from MainRoute:", data);
      setLoading(false);
    }

    initializeApp();

    return () => {
      controller.abort();
    };
  }, []);

  if (loading || jsonData === null) {
    return (
      <div
        className="main-content"
        style={{ alignItems: "center", justifyContent: "center" }}
      >
        <Spinner></Spinner>
        <div
          style={{
            color: "#fff",
            background: "blue",
            width: "50vw",
            height: "50vh",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            alignContent: "center",
          }}
        >
          กำลังโหลดข้อมูล
        </div>
      </div>
    );
  }

  return loading ? (
    <div
      className="main-content"
      style={{ alignItems: "center", justifyContent: "center" }}
    >
      <Spinner></Spinner>
      <div
        style={{
          color: "#000",
          // width: "100%",
          // height: "100%",
          marginTop:"25%",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          alignContent: "center",
        }}
      >
        กำลังโหลด...
      </div>
    </div>
  ) : (
    <div className="bg-main">
      <div className="main-contrainer">
        {globalState.auth ? (
          <NavigationBar menuList={menuList} dropdownList={dropdownRouteList} />
        ) : null}
        {IntitailRoute}
      </div>
    </div>
  );
};

function App() {
  return (
    <GlobalContextProvider>
      <HashRouter>
        <MainRoute />
      </HashRouter>
    </GlobalContextProvider>
  );
}

export default App;
